<div
  class="schedule-dialog"
  data-testid="schedule-dialog"
  role="dialog"
  [attr.aria-label]="hearingText.title()"
>
  <div class="schedule-dialog__header">
    <div class="schedule-dialog__heading">
      <h2 class="schedule-dialog__title">{{ hearingText.title() }}</h2>
      <p
        class="schedule-dialog__subtitle"
        data-testid="schedule-dialog-subject"
      >
        {{ formatPersonName(data.candidate.title) }} ({{
          data.candidate.proceedingNumber
        }})
      </p>
    </div>
    <button
      type="button"
      class="schedule-dialog__close"
      aria-label="Close"
      data-testid="schedule-dialog-close"
      (click)="cancel()"
    >
      &times;
    </button>
  </div>

  <div class="schedule-dialog__body">
    <p class="schedule-dialog__window" role="status">
      Earliest booking: {{ earliestDate | date: "MMM d, y" : "UTC" }}.
      <ng-container *ngIf="dueDate"
        >Hearing due: {{ dueDate | date: "MMM d, y" : "UTC" }}.</ng-container
      >
    </p>
    <p *ngIf="windowIssue" class="schedule-dialog__window-issue" role="alert">
      No available scheduling dates: {{ windowIssue }}.
    </p>
    <div class="schedule-dialog__field">
      <label class="schedule-dialog__label" for="schedule-dialog-date"
        >Date</label
      >
      <input
        id="schedule-dialog-date"
        class="schedule-dialog__input"
        type="date"
        data-testid="schedule-dialog-date"
        [(ngModel)]="date"
        [min]="earliestDate"
        [attr.max]="dueDate"
        [disabled]="isSaving()"
      />
    </div>

    <div class="schedule-dialog__row">
      <div class="schedule-dialog__field">
        <label class="schedule-dialog__label" for="schedule-dialog-start"
          >Start time</label
        >
        <input
          id="schedule-dialog-start"
          class="schedule-dialog__input"
          type="time"
          data-testid="schedule-dialog-start-time"
          [ngModel]="startTime"
          (ngModelChange)="onStartTimeChange($event)"
          [disabled]="isSaving()"
        />
      </div>
      <div class="schedule-dialog__field">
        <label class="schedule-dialog__label" for="schedule-dialog-end"
          >End time</label
        >
        <input
          id="schedule-dialog-end"
          class="schedule-dialog__input"
          type="time"
          data-testid="schedule-dialog-end-time"
          [ngModel]="endTime"
          (ngModelChange)="onEndTimeChange($event)"
          [disabled]="isSaving()"
        />
      </div>
    </div>

    <div class="schedule-dialog__field">
      <label class="schedule-dialog__label" for="schedule-dialog-location"
        >Location</label
      >
      <input
        id="schedule-dialog-location"
        class="schedule-dialog__input"
        type="text"
        data-testid="schedule-dialog-location"
        placeholder="Location name"
        [(ngModel)]="locationName"
        [disabled]="isSaving()"
      />
    </div>

    <div class="schedule-dialog__field">
      <label class="schedule-dialog__label" for="schedule-dialog-room"
        >Room</label
      >
      <input
        id="schedule-dialog-room"
        class="schedule-dialog__input"
        type="text"
        data-testid="schedule-dialog-room"
        placeholder="Room name"
        [(ngModel)]="roomName"
        [disabled]="isSaving()"
      />
    </div>
  </div>

  <div class="schedule-dialog__footer">
    <button
      type="button"
      class="schedule-dialog__button schedule-dialog__button--secondary"
      data-testid="schedule-dialog-cancel"
      [disabled]="isSaving()"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="schedule-dialog__button schedule-dialog__button--primary"
      data-testid="schedule-dialog-confirm"
      [disabled]="isSaving() || !!windowIssue"
      (click)="confirm()"
    >
      {{ isSaving() ? "Scheduling…" : hearingText.title() }}
    </button>
  </div>
</div>
